import React, { useState } from 'react';
import { func, string } from 'prop-types';
import { Form as FinalForm } from 'react-final-form';
import classNames from 'classnames';

import { FormattedMessage, useIntl } from '../../../util/reactIntl';
import { createSlug } from '../../../util/urlHelpers';

import { Form, PrimaryButton, Button } from '../..';

import css from './InquiryWithoutPaymentForm.module.css';

const renderForm = formRenderProps => {
  // FormRenderProps from final-form
  const {
    formId,
    className,
    rootClassName,
    handleSubmit,
    hide,
    currentUser,
    currentListing,
    isOwnListing,
    linkCopied,
    setLinkCopied,
  } = formRenderProps;
  const classes = classNames(rootClassName || css.root, className);
  if (hide) {
    return null;
  }

  const handleShareClick = () => {
    if (currentListing?.id?.uuid) {
      const listingId = currentListing.id.uuid;
      const listingTitle = currentListing.attributes?.title || '';
      const slug = createSlug(listingTitle);
      const rootURL = process.env.REACT_APP_MARKETPLACE_ROOT_URL;
      const contactUrl = `${rootURL}/l/${slug}/${listingId}/contact-supplier`;

      navigator.clipboard.writeText(contactUrl).then(() => {
        setLinkCopied(true);
        setTimeout(() => setLinkCopied(false), 3000);
      });
    }
  };

  return (
    <Form id={formId} onSubmit={handleSubmit} className={classes}>
      <div className={css.submitButton}>
        <PrimaryButton type="submit">
          <FormattedMessage id="InquiryWithoutPaymentForm.ctaButton" />
        </PrimaryButton>
      </div>

      {/* Share Contact Link button - only visible to listing owner */}
      {isOwnListing && currentListing?.id?.uuid && (
        <div className={css.shareButtonWrapper}>
          <Button
            type="button"
            className={css.shareContactLinkButton}
            onClick={handleShareClick}
          >
            {linkCopied ? 'Link Copied!' : 'Share Contact Form Link'}
          </Button>
        </div>
      )}
    </Form>
  );
};

const InquiryWithoutPaymentForm = props => {
  const intl = useIntl();
  const initialValues = {};
  const [linkCopied, setLinkCopied] = useState(false);

  return (
    <FinalForm
      initialValues={initialValues}
      {...props}
      intl={intl}
      linkCopied={linkCopied}
      setLinkCopied={setLinkCopied}
      render={renderForm}
    />
  );
};

InquiryWithoutPaymentForm.defaultProps = {
  rootClassName: null,
  className: null,
};

InquiryWithoutPaymentForm.propTypes = {
  rootClassName: string,
  className: string,

  // form
  formId: string.isRequired,
  onSubmit: func.isRequired,
};

export default InquiryWithoutPaymentForm;
